import { api } from "@/lib/api/api";
import { expectShape } from "@/lib/expect/expect-shape";
import { is } from "@/lib/is/is";
import { out } from "@/lib/output/out";
import { path } from "@/lib/path/path";
import type { ApiOutputs } from "@/lib/api/api-outputs";

export async function listQuestions(
  sessionId: string | undefined,
  asJson: boolean,
): Promise<void> {
  const result = expectShape<ApiOutputs["questions"]["list"]>(
    await api(
      sessionId ? path`/sessions/${sessionId}/questions` : "/questions",
    ),
    "GET /questions",
    { items: is.array },
  );
  if (asJson) {
    out.json(result);
    return;
  }
  if (result.items.length === 0) {
    out.line("Nothing waiting on you.");
    return;
  }
  out.table(
    result.items.map((batch) => [
      out.cell(batch.id),
      out.cell(batch.sessionId),
      `${batch.questions.length} question(s)`,
      out.cell(batch.sessionTitle),
    ]),
  );
}
